import * as React from "react";
import { CSSProperties } from "react";

interface IDividerProps {
	height?: number;
	color?: string;
}

const Divider = ({ height, color }: IDividerProps) => {
	const style: CSSProperties = {
		width: "100%",
		borderTopWidth: `${height || 2}px`,
		borderTopStyle: "solid",
		borderTopColor: `${color || "var(--sw-lightGray-color)"}`,
		boxSizing: "border-box",
	};

	return (
		<div style={style}/>
	);
};

export default Divider;

